/**
 * IFYS CMS enquiry form configuration (from www.ifys.com.au).
 * Submissions POST to the same endpoints and field names as the legacy site.
 *
 * On production (www.ifys.com.au), leave REACT_APP_IFYS_FORM_ORIGIN unset so forms
 * post to relative paths on the same domain.
 *
 * During local development, set REACT_APP_IFYS_FORM_ORIGIN=https://www.ifys.com.au
 * in .env.development to route submissions through the live CMS until cutover.
 */
export const RECAPTCHA_SITE_KEY = '6Ldew78lAAAAAIGpaODAcSxEJU6h4YTiFumuEJ8z';

export const IFYS_FORM_ORIGIN = (process.env.REACT_APP_IFYS_FORM_ORIGIN || '').replace(/\/$/, '');

export const IFYS_ENQUIRY_FORMS = {
  contact: {
    actionPath: '/contact/contact-ifys/',
    dataId: '430',
    subject: 'Attention: New Incoming IFYS Enquiry from - Contact IFYS',
    redirectPath: '/contact/contact-ifys/thank-you/',
  },
  partnerships: {
    actionPath: '/partnerships/partner-with-us/',
    dataId: '505',
    subject: 'Attention: New Incoming IFYS Enquiry from - Partner with Us',
    redirectPath: '/contact/contact-ifys/thank-you/',
  },
};

export const EMPTY_ENQUIRY_FORM = {
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  enquiry: '',
  newsletter: false,
};
